import React from "react";

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">ℹ️ हमारे बारे में</h2>
        <div className="about-content">
          <div className="about-text">
            <div className="mission-vision">
              <div className="mission">
                <h3>🎯 हमारा मिशन</h3>
                <p>
                  Vision एक स्वैच्छिक समुदायिक समूह है जो कटनी, मध्य प्रदेश में
                  शहर की सफाई के क्षेत्र में अग्रणी भूमिका निभा रहा है। हमारा
                  मुख्य उद्देश्य शहरी स्वच्छता, कचरा प्रबंधन, नदी सफाई,
                  वृक्षारोपण और पर्यावरणीय जागरूकता के माध्यम से एक स्वच्छ शहर
                  का निर्माण करना है।
                </p>
              </div>
              <div className="vision">
                <h3>🔮 हमारा विजन</h3>
                <p>
                  एक स्वच्छ, हरित और स्वस्थ शहर का निर्माण करना जहाँ हर नागरिक
                  स्वच्छता के प्रति जिम्मेदार हो। हम चाहते हैं कि कटनी एक आदर्श
                  स्वच्छ शहर बने जो अन्य शहरों के लिए मिसाल हो।
                </p>
              </div>
            </div>

            <div className="our-approach">
              <h3>🌟 हमारा दृष्टिकोण</h3>
              <p>
                हमारे द्वारा चलाए जा रहे विभिन्न प्रोजेक्ट्स के माध्यम से हम
                समुदाय के साथ मिलकर शहर की व्यापक सफाई कर रहे हैं। हमारे कार्यों
                में कचरा प्रबंधन, नदी सफाई, स्वच्छता अभियान, वृक्षारोपण, पक्षी
                संरक्षण और प्लास्टिक मुक्त वातावरण बनाना शामिल है।
              </p>
              <p>
                हमारा विश्वास है कि हर छोटा प्रयास मिलकर बड़ा बदलाव लाता है।
                इसीलिए हम निरंतर नागरिकों के साथ मिलकर शहर को साफ और सुंदर बनाने
                के लिए काम कर रहे हैं।
              </p>
            </div>

            <div className="our-values">
              <h3>💎 हमारे मूल्य</h3>
              <div className="values-grid">
                <div className="value-item">
                  <h4>🧹 स्वच्छता</h4>
                  <p>शहर की व्यापक सफाई और रखरखाव</p>
                </div>
                <div className="value-item">
                  <h4>🤝 सहयोग</h4>
                  <p>समुदायिक भागीदारी और सामूहिकता</p>
                </div>
                <div className="value-item">
                  <h4>💡 जागरूकता</h4>
                  <p>सफाई और पर्यावरण संरक्षण की शिक्षा</p>
                </div>
                <div className="value-item">
                  <h4>❤️ स्वैच्छिकता</h4>
                  <p>निःस्वार्थ सेवा और समर्पण</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-image">
            <div className="image-gallery">
              <div className="main-image">
                <img
                  src="/assets/founder_notes.jpeg"
                  alt="संस्थापक की टिप्पणी"
                />
              </div>
              <div className="env-images-grid">
                <img
                  src="/assets/taru/image.png"
                  alt="वृक्षारोपण"
                  className="env-image"
                />
                <img
                  src="/assets/projectnirmal/1.png"
                  alt="तालाब सफाई"
                  className="env-image"
                />
                <img
                  src="/assets/vasundhara/1.png"
                  alt="पृथ्वी दिवस"
                  className="env-image"
                />
                <img
                  src="/assets/wallpaintings/1.png"
                  alt="दीवार चित्रकारी"
                  className="env-image"
                />
              </div>
            </div>

            <div className="location-info">
              <h4>📍 हमारा स्थान</h4>
              <p>
                <strong>🏢 कटनी, मध्य प्रदेश</strong>
              </p>
              <p>🎯 जिला मुख्यालय से संचालित</p>
              <p>🗺️ सेवा क्षेत्र: संपूर्ण कटनी जिला</p>
            </div>
          </div>
        </div>

        <div className="achievements">
          <h3 className="subsection-title">🏆 हमारी उपलब्धियां</h3>
          <div className="achievements-grid">
            <div className="achievement-item">
              <span className="achievement-number">1500+</span>
              <span className="achievement-label">🌱 पौधे रोपित</span>
            </div>
            <div className="achievement-item">
              <span className="achievement-number">7</span>
              <span className="achievement-label">🚀 सक्रिय प्रोजेक्ट्स</span>
            </div>
            <div className="achievement-item">
              <span className="achievement-number">500+</span>
              <span className="achievement-label">👥 जागरूक नागरिक</span>
            </div>
            <div className="achievement-item">
              <span className="achievement-number">25+</span>
              <span className="achievement-label">🎓 शिक्षा कार्यक्रम</span>
            </div>
            <div className="achievement-item">
              <span className="achievement-number">6</span>
              <span className="achievement-label">📍 क्षेत्रों में सेवा</span>
            </div>
            <div className="achievement-item">
              <span className="achievement-number">100%</span>
              <span className="achievement-label">🆓 निःशुल्क सेवा</span>
            </div>
          </div>
        </div>

        <div className="environmental-showcase">
          <h3>🌍 पर्यावरण संरक्षण में हमारे प्रयास</h3>
          <div className="showcase-grid">
            <div className="showcase-item">
              <img src="/assets/taru/image1.png" alt="वृक्षारोपण कार्यक्रम" />
              <h4>🌳 वृक्षारोपण</h4>
              <p>शहर में हरियाली बढ़ाने के लिए व्यापक वृक्षारोपण</p>
            </div>
            <div className="showcase-item">
              <img src="/assets/projectnirmal/2.png" alt="जल संरक्षण" />
              <h4>💧 जल संरक्षण</h4>
              <p>तालाबों की सफाई और जल संरक्षण के प्रयास</p>
            </div>
            <div className="showcase-item">
              <img src="/assets/wallpaintings/2.png" alt="जागरूकता अभियान" />
              <h4>🎨 जागरूकता अभियान</h4>
              <p>कलात्मक तरीकों से पर्यावरण संरक्षण की जागरूकता</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
